import React from 'react';
import { Link } from 'react-router-dom';
import './Subfooter.css'; 

const Subfooter: React.FC = () => (
  <section className="subfooter-section">
    <div className="subfooter-container">

      <div className="subfooter-slogan">
         <p>
          Das Allgäuer Expertennetzwerk für Umwelt- und Energietechnik<br />
          Gemeinsam für eine nachhaltige Zukunft.
        </p>
      </div>

      <div className="subfooter-contact">
        <p>
          <a href="mailto:info@waermeplanung-bayern.de">info@beispiel.de</a> |{' '}
          <a href="https://www.waermeplanung-bayern.de" target="_blank" rel="noopener noreferrer">
            www.beispiel.de
          </a>
        </p>
      </div>

      <div className="subfooter-bottom">
        <div>
          <Link to="/impressum" onClick={() => window.scrollTo(0, 0)}>Impressum</Link>
          <span> | </span>
          <Link to="/datenschutz" onClick={() => window.scrollTo(0, 0)}>Datenschutz</Link>
        </div>
        <div className="subfooter-copy">
          © 2025
        </div>
      </div>

    </div>
  </section>
);

export default Subfooter;
